var router = require('pjax').Router;
var index = require('./index.js');
var form = require('./form.js');
var slideshow = require('./slideshow.js');

router.get('judge/([a-zA-Z]+)', form);
router.get('judge/([a-zA-Z]+)/slideshow', slideshow);
router.get('judge', index);
